const useGlobal = () => {
  const userOnline = navigator.onLine;
  return {
    userOnline,
  };
};

export default useGlobal;